import React from 'react';
import styles from './StatusBadge.module.css';

export type TicketStatus =
  | 'Open'
  | 'In Progress'
  | 'Waiting'
  | 'Resolved'
  | 'Closed'
  | 'Pending Review'
  | 'Approved'
  | 'Rejected';

interface StatusBadgeProps {
  status: TicketStatus;
}

const statusKey = (s: string) => s.replace(/\s+/g, '').toLowerCase();

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  return (
    <span className={`${styles.badge} ${styles[statusKey(status)]}`}>
      <span className={styles.dot} />
      {status}
    </span>
  );
};
